import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { Box } from '@material-ui/core';
import Info from '../desktop/Info';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { EXCHANGE_DETAIL_ROUTE } from '../../../../../../constants/Routes';
import { useContainerStyles } from './styles';

const Container = ({ ...props }) => {
  const { row, instructions, inside, balance } = props;
  const [instruction, setInstruction] = useState({});

  useEffect(() => {
    Boolean(instructions) &&
      setInstruction(
        instructions.filter(
          (instruction) => instruction.categoryId === row.category,
        ),
      );
  }, [instructions]);

  const classes = useContainerStyles();
  const location = useLocation();
  return (
    <React.Fragment>
      {row?.image && (
        <Link
          to={{
            pathname: EXCHANGE_DETAIL_ROUTE,
            state: {
              row,
              instruction,
              balance,
              prevRoute: location.pathname,
            },
          }}
          className={classes.link}
          data-cy="linkgift-card"
        >
          <Box
            display="flex"
            alignItems="center"
            margin="17px 0px"
            width="100%"
          >
            <img src={row.image} className={classes.image} />
            <Info
              className={classes.info}
              category={row.category}
              expirationDate={row.expirationDate}
              creationDate={row.createdAt}
              balance={balance}
            />
            {!inside && <KeyboardArrowRightIcon fontSize="large" />}
          </Box>
        </Link>
      )}
    </React.Fragment>
  );
};

Container.propTypes = {
  row: PropTypes.object,
  instructions: PropTypes.array,
  inside: PropTypes.bool,
  balance: PropTypes.string,
};

export default Container;
